export default __webpack_public_path__ + "static/media/angularFirstView.485686c4.JPG";